import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
export function ProblemSection() {
  const transformations = ['ordenar la evaluación paso a paso', 'usar los tests con lógica clínica', 'construir hipótesis con más claridad', 'diferenciar cuadros parecidos', 'detectar cuándo tratar y cuándo derivar', 'estudiar sin sentirte perdido'];
  return <AnimatedSection className="bg-navy-950 relative overflow-hidden" data-id="element-225">
      {/* Subtle dot pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-226">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, rgba(201,168,76,0.4) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-227" />
      </div>

      {/* Soft glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[500px] bg-gold/[0.04] blur-[120px] rounded-full pointer-events-none" data-id="element-228"></div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
        {/* Big editorial pull quote */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 sm:mb-12" data-id="element-230">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/5 text-gold text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase mb-4 sm:mb-6" data-id="element-231">
            El diagnóstico
          </div>
          <h2 className="font-heading font-extrabold text-xl sm:text-3xl md:text-5xl text-white leading-[1.2] tracking-tight max-w-3xl mx-auto" data-id="element-232">
            Si hoy sentís que{' '}
            <span className="text-gray-400" data-id="element-233">sabés teoría</span>, pero todavía no
            sabés{' '}
            <span className="font-editorial italic text-gold font-medium" data-id="element-234">
              evaluar con orden
            </span>
            , no te falta capacidad.
          </h2>
          <p className="mt-4 sm:mt-6 font-heading font-extrabold text-2xl sm:text-4xl md:text-5xl text-white leading-tight" data-id="element-235">
            Te falta{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-light to-gold" data-id="element-236">
              sistema
            </span>
            .
          </p>
        </motion.div>

        {/* Bridge paragraph */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-sm sm:text-lg text-gray-300 leading-relaxed text-center max-w-3xl mx-auto mb-8 sm:mb-12 px-2" data-id="element-237">
          El{' '}
          <span className="font-bold text-white" data-id="element-238">Mega Pack Kinesiología</span>{' '}
          organiza en un solo lugar todo lo que necesitás para integrar{' '}
          <span className="font-editorial italic text-gold/90" data-id="element-239">
            anamnesis, movilidad, fuerza, tests, red flags y razonamiento
            clínico
          </span>
          , y llegar mucho más seguro a prácticas, internado y consulta.
        </motion.p>

        {/* Transformation list */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-gradient-to-b from-navy-900 to-navy-900/40 border border-gold/15 rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-12 backdrop-blur-sm" data-id="element-240">
          <div className="text-[10px] sm:text-xs font-bold tracking-[0.2em] uppercase text-gold mb-4 sm:mb-6 text-center" data-id="element-241">
            Con el Mega Pack vas a poder
          </div>

          <ul className="space-y-2.5 sm:space-y-4 max-w-2xl mx-auto" data-id="element-242">
            {transformations.map((item, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3 + idx * 0.06
          }} className="flex items-start gap-3 sm:gap-4 text-sm sm:text-lg text-white/90 leading-relaxed group" data-id="element-243">
                <div className="mt-0.5 sm:mt-1 w-5 h-5 sm:w-7 sm:h-7 rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center flex-shrink-0 group-hover:bg-gold/25 transition-colors" data-id="element-244">
                  <Check size={12} className="text-gold sm:w-3.5 sm:h-3.5" strokeWidth={3} data-id="element-245" />
                </div>
                <span data-id="element-246">{item}</span>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </AnimatedSection>;
}